@if (!refreshing) {
  <div class="icc-capture-detail">
    <div class="row mx-0 mb-2">
      <div class="col-6 px-0 text-start">
        <nav class="nav nav-pills">
          <a
            class="nav-item nav-link"
            routerLink="../{{capture.id}}"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            >
            Capture Details
          </a>
        </nav>
      </div>
    </div>
    <div class="border py-2 rounded">
      <div class="row mx-1">
        <div class="col">
          <strong>CAPTURE ID</strong>
          <div>{{ capture.id }}</div>
        </div>
        <div class="col">
          <strong>STATUS</strong>
          <div>{{ capture.status }}</div>
        </div>
        <div class="col">
          <strong>CLIENT</strong>
          <div>{{ capture.client.humanizedName }}</div>
          @if (capture.ehrAccess) {
            <div
              class="indicator-pill indicator-pill-green indicator-pill-full-width">
              EHR Access
            </div>
          }
        </div>
        <div class="col">
          <strong>RX-PATIENT</strong>
          <div class="phi">{{ capture.claim.patientFirst }} {{ capture.claim.patientLast }}</div>
          <div class="small text-nowrap phi"><strong>MRN:</strong> {{ capture.claim.patientMrn }}</div>
          <div class="small text-nowrap phi"><strong>DOB:</strong> {{ capture.claim.patientDob | date: 'MM/dd/yyyy' }}</div>
        </div>
        <div class="col">
          <strong>OPPORTUNITY VALUE</strong>
          <div>{{ capture.opportunityValue | currency }}</div>
        </div>
      </div>
    </div>
    <div class="card mt-1">
      <div class="card-body">
        <h4 class="eligible-header">AUTOMATED CLAIM ELIGIBILITY CHECKS</h4>
        @if (capture.eligibilityStatus === 'eligible') {
          <div class="eligible-flag pass">ELIGIBLE</div>
        }
        @if (capture.eligibilityStatus !== 'eligible') {
          <div class="eligible-flag fail">INELIGIBLE</div>
        }
        @if (capture.providerStatus === 'eligible') {
          <div class="pass">
            <fa-icon [icon]="['fas', 'check-circle']" size="1x" class="check" />
            <strong>PRESCRIBER CHECK</strong>
            <span>The script was written by an eligible prescriber during time the prescriber was eligible for the client organization</span>
          </div>
        }
        @if (capture.providerStatus !== 'eligible') {
          <div class="fail">
            <fa-icon [icon]="['fas', 'times-circle']" size="1x" class="check" />
            <strong>PRESCRIBER CHECK</strong>
            <span>The script was not written by an eligible prescriber during time the prescriber was eligible for the client organization</span>
          </div>
        }
        @if (capture.medicaidStatus === 'eligible') {
          <div class="pass">
            <fa-icon [icon]="['fas', 'check-circle']" size="1x" class="check" />
            <strong>MEDICAID CHECK</strong>
            <span>This is a non medicaid claim or this pharmacy carves in Medicaid claims</span>
          </div>
        }
        @if (capture.medicaidStatus !== 'eligible') {
          <div class="fail">
            <fa-icon [icon]="['fas', 'times-circle']" size="1x" class="check" />
            <strong>MEDICAID CHECK</strong>
            <span>This is an ineligible Medicaid claim or we have insufficient information to categorize this claim</span>
          </div>
        }
        @if (capture.drugStatus === 'eligible' || capture.drugExemptionStatus === 'exempt') {
          <div class="pass">
            <fa-icon [icon]="['fas', 'check-circle']" size="1x" class="check" />
            <strong>DRUG CHECK</strong>
            <span>This is a 340B eligible drug</span>
          </div>
        }
        @if (capture.drugStatus !== 'eligible' && capture.drugExemptionStatus !== 'exempt') {
          <div class="fail">
            <fa-icon [icon]="['fas', 'times-circle']" size="1x" class="check" />
            <strong>DRUG CHECK</strong>
            <span>This is not a 340B eligible drug</span>
          </div>
        }
        @if (capture.pricingStatus === 'complete') {
          <div class="pass">
            <fa-icon [icon]="['fas', 'check-circle']" size="1x" class="check" />
            <strong>PRICING CHECK</strong>
            <span>All pricing information is available for this claim</span>
          </div>
        }
        @if (capture.pricingStatus !== 'complete') {
          <div class="fail">
            <fa-icon [icon]="['fas', 'times-circle']" size="1x" class="check" />
            <strong>PRICING CHECK</strong>
            <span>All pricing information is not available for this claim</span>
          </div>
        }
      </div>
    </div>
    <div class="row m-0 p-0">
      <div class="col card mt-1 bg-light">
        <div class="card-body">
          <h4>ELIGIBILITY FINDINGS</h4>
          @if (capture.eligibilityFindings) {
            <h5 class="mt-3">Findings</h5>
            <div class="row my-2">
              <div class="col">
                <strong>ELIGIBILITY FINDING</strong>
                <div>{{ capture.eligibilityFindings.eligibilityStatus }}</div>
              </div>
              <div class="col">
                <strong>FINDINGS CATEGORY</strong>
                <div>{{ capture.eligibilityFindings.eligibilityStatusReason }}</div>
              </div>
            </div>
            <div class="row my-2">
              <div class="col">
                <strong>FINDINGS NOTE</strong>
                <div class="phi">{{ capture.eligibilityFindings.note }}</div>
              </div>
            </div>
            <div class="row my-2">
              <div class="col">
                <strong>SUBMITTED TO CLIENT</strong>
                <div>{{ capture.eligibilityFindings.clientSubmitDate | date: 'MM/dd/yyyy' }}</div>
              </div>
            </div>
            <h5 class="mt-3">Eligible Findings Details</h5>
            <div class="row my-2">
              <div class="col">
                <strong>DEPARTMENT</strong>
                <div>{{ capture.eligibilityFindings.department }}</div>
              </div>
              <div class="col">
                <strong>ENCOUNTER ID</strong>
                <div>{{ capture.eligibilityFindings.encounterIdentifier }}</div>
              </div>
            </div>
            <div class="row my-2">
              <div class="col">
                <strong>EHR-MRN</strong>
                <div class="phi">{{ capture.eligibilityFindings.patientMrn }}</div>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="col card bg-light mt-1 ms-1">
        <div class="card-body">
          <h4>CLAIM DETAILS</h4>
          <h5 class="mt-3">TPA Information</h5>
          <div class="row my-2">
            <div class="col">
              <strong>RX-TPA</strong>
              <div>{{ capture.claim.thirdPartyAdminister?.name }}</div>
            </div>
            <div class="col">
              <strong>RX-TPA CLAIM ID</strong>
              <div>{{ capture.claim.claimIdentifier }}</div>
            </div>
          </div>
          <h5 class="mt-3">Prescriber Information</h5>
          <div class="row my-2">
            <div class="col">
              <strong>RX-PRESCRIBER</strong>
              <div>{{ capture.claim.prescriberFirst }} {{ capture.claim.prescriberLast }}</div>
              <div class="small">
                <strong>NPI:</strong>
                {{ capture.claim.prescriberNpi }}
              </div>
            </div>
          </div>
          <h5 class="mt-3">Drug Information</h5>
          <div class="row my-2">
            <div class="col">
              <strong>RX-NDC</strong>
              <div>{{ capture.claim.ndc }}</div>
            </div>
            <div class="col">
              <strong>RX-WRITTEN DATE</strong>
              <div>{{ capture.claim.writtenDate | date: 'MM/dd/yyyy' }}</div>
            </div>
          </div>
          <div class="row my-2">
            <div class="col">
              <strong>RX-DRUG</strong>
              <div>{{ capture.claim.drugDescription }}</div>
            </div>
            <div class="col">
              <strong>RX-SERVICE DATE</strong>
              <div>{{ capture.claim.serviceDate | date: 'MM/dd/yyyy' }}</div>
            </div>
          </div>
          <div class="row my-2">
            <div class="col">
              <strong>RX-#</strong>
              <div>{{ capture.claim.referenceNumber }}</div>
              <div class="small">
                <strong>Fill:</strong>
                {{ capture.claim.fillNumber }}
              </div>
            </div>
            <div class="col">
              <strong>RX-PHARMACY</strong>
              <div>{{ capture.claim.pharmacyName }}</div>
              <div class="small">
                <strong>ID:</strong>
                {{ capture.claim.pharmacyIdentifier }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <mat-spinner />
}
